import { convertArabicNumerals } from '@/utils/arabic-numerals'

const DEFAULT_OTP_CODE_LENGTH = 4

/** Translation keys for OTP channel display labels */
export const OTP_CHANNEL_TRANSLATION_KEYS = {
  sms: 'single_checkout_login_otp_method_sms',
  push_notification: 'single_checkout_login_otp_method_pn',
  whatsapp: 'single_checkout_login_otp_method_wa',
}

const OTP_CHANNEL_SEPARATOR = {
  arabic: ' و ',
  default: ' & ',
}

/**
 * Returns the display label for OTP channel(s) used.
 * @param {Array|{used?: string}} otpChannels - Array of channel names or object with single `used` channel
 * @param {{ t: (key: string) => string, isArabic?: boolean }} options - `t` for i18n, `isArabic` for separator
 * @returns {string} Translated label(s), joined when multiple channels
 */
export function getOtpChannelsUsedLabel(otpChannels, { t, isArabic = false }) {
  const hasChannelsArray = Array.isArray(otpChannels) && otpChannels.length > 0

  if (hasChannelsArray) {
    const separator = isArabic
      ? OTP_CHANNEL_SEPARATOR.arabic
      : OTP_CHANNEL_SEPARATOR.default
    return otpChannels
      .map((c) =>
        t(
          OTP_CHANNEL_TRANSLATION_KEYS[c?.toLowerCase()] ||
            OTP_CHANNEL_TRANSLATION_KEYS.sms
        )
      )
      .join(separator)
  }

  const used = otpChannels?.used
  const key =
    used === 'push_notification'
      ? OTP_CHANNEL_TRANSLATION_KEYS.push_notification
      : used === 'whatsapp'
      ? OTP_CHANNEL_TRANSLATION_KEYS.whatsapp
      : OTP_CHANNEL_TRANSLATION_KEYS.sms
  return t(key)
}

const sanitizeOtpCode = (input, submitting) => {
  // XXX allow spaces in otp code while editing
  const regex = submitting ? /\D/g : /[^ 0-9]/g
  return convertArabicNumerals(input || '').replace(regex, '')
}

const isValidOtpCode = (input) => {
  return (
    input &&
    input.length === DEFAULT_OTP_CODE_LENGTH &&
    sanitizeOtpCode(input, true).length === DEFAULT_OTP_CODE_LENGTH
  )
}

export { sanitizeOtpCode, isValidOtpCode, DEFAULT_OTP_CODE_LENGTH }
